<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Jack Compton’s Luck</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="titlePage" id="tp01"><a id="page03"><h2 class="titlePageAuthor"><span class="bold"><span><em class="italic"><span>Paula Marshall</span></em></span></span></h2><h2 class="titlePageTitle"><span class="bold"><span>J<span class="smallCaps1"><span>ACK</span></span> C<span class="smallCaps1"><span>OMPTON’S</span></span> L<span class="smallCaps1"><span>UCK</span></span></span></span></h2><p class="image"><span><img alt="image" src="Images/logo.jpg"/></span></p><p class="titlePageCity"><span><span class="smallCaps"><span>TORONTO • NEW YORK • LONDON<br/>
AMSTERDAM • PARIS • SYDNEY • HAMBURG<br/>
STOCKHOLM • ATHENS • TOKYO • MILAN • MADRID<br/>
PRAGUE • WARSAW • BUDAPEST • AUCKLAND</span></span></span></p></a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jackcomptonsluck_tp01.vue?5041fece